export default "__VITE_ASSET__CeJik88P__"